import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TypedFormBuilder, TypedFormGroup } from '@gmrappdev/formsafe';
import { Subject } from 'rxjs';
import { NdrRecordViewModel } from 'src/view-models/ndr-record-view-model';
import { PrdProcessingState } from 'src/view-models/pilot-view-model';
import { PrdProcessingStateSelectItems } from '../pilot-form/pilot-form.component';

@Component({
  selector: 'fl-pilot-ndr-record-form',
  templateUrl: './pilot-ndr-record-form.component.html',
  styleUrls: ['./pilot-ndr-record-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PilotNdrRecordFormComponent implements OnInit, OnDestroy {
  @Input()
  public ndrRecord?: NdrRecordViewModel;
  @Input()
  public pilotId: string;

  public form: TypedFormGroup<NdrRecordViewModel>;

  public _onDestroy$ = new Subject<void>();

  public minDate = new Date(1950, 0, 1);
  public maxDate = new Date(Date.now());

  public processingStateOptions = PrdProcessingStateSelectItems;
  public disableProcessingState = false;

  constructor(private _tfb: TypedFormBuilder) {}

  public ngOnInit() {
    const ndrRecord: Partial<NdrRecordViewModel> = this.ndrRecord != null ? this.ndrRecord : {};
    this.form = this._tfb.group<NdrRecordViewModel>({
      id: [ndrRecord.id],
      pilotId: [this.pilotId],
      ndrRequestDate: [ndrRecord.ndrRequestDate],
      lastProcessedDate: [ndrRecord.lastProcessedDate],
      prdSourceSystemId: [ndrRecord.prdSourceSystemId],
      processingError: [ndrRecord.processingError],
      processingState: [ndrRecord.processingState ?? PrdProcessingState.ReadyForTransmission],
      suppressed: [ndrRecord.suppressed ?? false],
    });
  }

  public ngOnDestroy() {
    this._onDestroy$.next();
  }
}
